import { t } from 'ttag';

import { Title } from '@ui/Title';
import { Skeleton } from '@ui/Skeleton';

import s from './ProductDetailsPromotionServices.sss';

export const ProductDetailsPromotionServicesSkeleton = () => (
  <div className={s.root}>
    <Title
      className={s.title}
      type="h3"
      bold={false}
    >
      {t`Просування оголошення`}
    </Title>

    <p className={s.description}>
      {t`Виберіть один із пакетів реклами для швидкого продажу речей`}
    </p>

    <ul className={s.list}>
      {Array(5).fill(null).map((_, i) => (
        <li
          key={i}
          className={s.item}
        >
          <Skeleton
            width="100%"
            height="70px"
          />
        </li>
      ))}
    </ul>
  </div>
);
